/**
 *
 *
 */
export function requestSubmit(
  form: HTMLFormElement | null,
  {
    formId,
    formaction,
    formmethod,
  }: {
    formId?: string;
    formaction?: string;
    formmethod?: string;
  },
) {
  const btn = document.createElement("button");
  btn.style.display = "none";
  btn.type = "submit";
  if (formmethod) btn.setAttribute("formmethod", formmethod);
  if (formaction) btn.setAttribute("formaction", formaction);
  if (formId) btn.setAttribute("form", formId);

  form?.appendChild(btn);
  form?.requestSubmit(btn);
  form?.removeChild(btn);
}
